import { styled } from '@mui/material';

const HyperLink = styled('a')(({ theme }) => ({
	color: theme.palette.primary.main,
	'&:hover': {
		color: theme.palette.primary.light,
	},
	'&:visited': {
		color: theme.palette.primary.dark,
		'&:hover': {
			color: theme.palette.primary.light,
		},
	},
}));

export default HyperLink;
